import React, { Component } from 'react';
import './EditorContainer.css';

import DynamicArea from '../dynamic-area/DynamicArea';

class EditorContainer extends Component {
  render() {
    const { lang } = this.props;
    return (
      <div className="BookDesigner_ContentArea_LayoutEditor_Wrapper">
        <DynamicArea
          lang={lang}
        />
      </div>
    );
  }
}

export default EditorContainer;



// WEBPACK FOOTER //
// ./src/components/editor-container/EditorContainer.jsx